import { OptionType } from "components";
import { COUNTRY_NAMES } from "./countries";

// The country list is bundled locally (see ./countries). It mirrors the names
// previously returned by restcountries.com/v3.1, which has been deprecated and
// now responds with an error payload instead of a list, leaving the dropdown
// empty. Serving the same names statically keeps values consistent with what is
// already stored and removes the external network dependency.
const countryOptions: OptionType[] = COUNTRY_NAMES.map((name) => ({
  label: name,
  value: name,
}));

export const useFetchCountries = () => {
  // Kept as a no-op so existing callers that trigger fetchCountries() in an
  // effect continue to work without changes.
  const fetchCountries = () => {};

  return { fetchCountries, countries: countryOptions, loading: false };
};
